import { storePage } from "@/stores/page.js";
import $axios from "@/axios";

export default {
  //請求分類
  get: async function () {
    await $axios
      .post("/api/admin/page_get.php")
      .then(function (res) {
        if (res.data.result == "pass") {
          storePage.pages = res.data.pages;
        } else {
          console.log(res.data);
        }
      })
      .catch(function (err) {
        console.log(err);
      });
  },
};
